/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_Q2Inputs */

const en_cad_faq_q2 = /** @type {(inputs: Cad_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is CADCraft made by Autodesk?`)
};

/**
* | output |
* | --- |
* | "Is CADCraft made by Autodesk?" |
*
* @param {Cad_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_q2 = /** @type {((inputs?: Cad_Faq_Q2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_Q2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_q2(inputs)
});
export { cad_faq_q2 as "cad.faq.q2" }